import React from 'react';
import './MediaUpload.scss';
import {ADMIN_ROLE} from '../../constants/global';


const EmptyFileView = ({onFileLoad, org_role, acceptTypes}) => {

return (<div className={org_role===ADMIN_ROLE?'uploadrowadmin':'uploadrow'}>
          <input type='text' id='inputFileName' readOnly style={{height:'40px', marginRight:'20px', width:'60%'}}/> 
          {org_role===ADMIN_ROLE?
          <>
            <button type='button' className={`cb-btn cb-btn-primary`} disabled style={{marginLeft:'10px'}}>Reject</button>
            <button type='button' className={`cb-btn cb-btn-primary`} disabled>Accept</button>
          </>
          :
          <>
            <label htmlFor="inputFileUpload" id='labelUpload' style={{marginTop:'0px'}}>
              <button type='button' className='cb-btn cb-btn-primary' aria-describedby={`browse`} 
                style={{marginLeft:'20px'}}>
                <span>Browse</span>
              </button>

              <input type="file" accept={acceptTypes} id="inputFileUpload" name="fileF" onChange={e=>onFileLoad(e)} onClick={e=>{e.target.value = null;}} /> 
            </label>
          </> }
        </div>
  );
};

export default EmptyFileView;